<template>
    <h2>This is Manage Home page.</h2>
</template>

<script>
    export default {
        name: 'ManageHomePage',
    };
</script>
